import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { useTranslation } from 'react-i18next';

interface BuyerJobListSkeletonProps {
  count?: number;
}

export const BuyerJobListSkeleton = ({
  count = 5,
}: BuyerJobListSkeletonProps): JSX.Element => {
  const { t } = useTranslation();

  return (
  <Box
    aria-busy
    aria-label={t('jobs.loadingJobs')}
    sx={{
      overflow: 'hidden',
      border: 1,
      borderColor: 'divider',
      borderRadius: 3,
      bgcolor: 'background.paper',
    }}
  >
    {Array.from({ length: count }, (_, index) => (
      <Box
        key={index}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1.75,
          borderBottom: index === count - 1 ? 0 : 1,
          borderColor: 'divider',
        }}
      >
        <Skeleton
          variant="rounded"
          width={44}
          height={44}
          sx={{ bgcolor: 'action.hover', flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Skeleton
            variant="text"
            width="58%"
            height={18}
            sx={{ bgcolor: 'action.hover' }}
          />
          <Skeleton
            variant="text"
            width="36%"
            height={14}
            sx={{ mt: 0.5, bgcolor: 'action.hover' }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: 0.5,
            flexShrink: 0,
          }}
        >
          <Skeleton
            variant="text"
            width={56}
            height={18}
            sx={{ bgcolor: 'action.hover' }}
          />
          <Skeleton
            variant="text"
            width={44}
            height={12}
            sx={{ bgcolor: 'action.hover' }}
          />
        </Box>
      </Box>
    ))}
  </Box>
  );
};
